import { databasesPingRegistry } from './ping-registry.ts';

// Named exports for destructuring
export const { key, subscribe, subscribeTo, notify } = databasesPingRegistry;

// Default export for full registry access
export default databasesPingRegistry;

export { useDatabaseSelectionSnapshot } from './use-database-selection-snapshot.ts';

/**
 * Subscribes to selection state changes for a specific entity via
 * ping registry and re-reads from `SelectionsReader`. See {@link useSelectionPing} for full docs.
 */
export { useDatabaseSelectionPing } from './use-selection-ping.ts';
export { useFieldSelectionState } from './use-field-selection-state.ts';
export { useRowSelectionHandleActive } from './use-row-selection-handle-active.ts';
